import React from 'react';
import SectionHeader from '../ui/SectionHeader';
import Reveal from '../ui/Reveal';
import testimonials from '../../data/testimonials.json';
import './Testimonials.css';

const Testimonials = () => {
  return (
    <section className="testimonials tra-section" id="testimonials">
      <div className="tra-container">
        <SectionHeader
          eyebrow="Testimonials"
          title="Creators love working with us"
          subtitle="Don't take our word for it — hear it from the talent we represent."
        />

        <div className="testimonials__grid">
          {testimonials.map((t, i) => (
            <Reveal className="testimonial-card" key={t.id} delay={i * 0.1}>
              <div className="testimonial-card__quote-mark" aria-hidden="true">"</div>
              <p className="testimonial-card__quote">{t.quote}</p>

              {t.highlight && (
                <div className="testimonial-card__highlight">{t.highlight}</div>
              )}

              <div className="testimonial-card__author">
                <img src={process.env.PUBLIC_URL + t.image} alt={t.name} loading="lazy" />
                <div>
                  <span className="testimonial-card__name">{t.name}</span>
                  <span className="testimonial-card__role">{t.role}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
